import angular from 'angular';
import userEditComponent from './user-edit.component';

const userEditModule = angular.module('userEdit', [
])
  .component('userEdit', userEditComponent)
  .name;

export default userEditModule;
